import styled, { css } from 'styled-components';
import wire from '../../assets/images/wire.png';

const StyledSvg = styled.svg`
	position: absolute;
	top: 15px;
	right: 35px;
	transform-origin: center;
`;

const StyledContainer = styled.div<{ $side: 'left' | 'right' }>`
	position: relative;
	width: 260px;
	height: 60px;
	background-image: url(${wire});
	background-size: contain;
	background-repeat: no-repeat;
	transform-origin: center;

	${(props) =>
		props.$side === 'right' &&
		css`
			transform: rotate(180deg);

			${StyledSvg} {
				transform: rotate(180deg);
			}
		`}
`;

export { StyledContainer, StyledSvg };
